export const environment = {
    urlSrc: process.env.VUE_APP_GENERIC_URL
}
